import React from 'react';

import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { TOURNAMENTS, TOURNAMENTS_REWARDS } from '@/routing/routes';
import { TOURNAMENT } from '@/analytics';

function TournamentHeaderTabs({ active }) {
    return (
        <HeaderTabsContainer>
            <TabButton
                route={TOURNAMENTS}
                i18nCode="tournaments.tournaments"
                trackData={{ category: TOURNAMENT, action: 'tournament-tab' }}
                activeRoute={active}
                data-atid={'tournament-tab-tournaments'}
            />
            <TabButton
                route={TOURNAMENTS_REWARDS}
                i18nCode="tournaments.rewards"
                trackData={{ category: TOURNAMENT, action: 'rewards-tab' }}
                activeRoute={active}
                data-atid={'tournament-tab-rewards'}
            />
        </HeaderTabsContainer>
    );
}

export default TournamentHeaderTabs;
